import { DefaultQueryParams, PaginatedResponse } from '@frontend/api-utils';

export interface CostCenter {
    name: string;
    update_timestamp: string;
    id: string;
    account_id: string;
    creation_timestamp: string;
    status: CostCenterStatus;
}

export interface CreateCostCenter {
    name?: string;
    status?: CostCenterStatus;
}

export interface UpdateCostCenter {
    name?: string;
    status?: CostCenterStatus;
}

export enum CostCenterStatus {
    ACTIVE = 'active',
    RETIRED = 'retired'
}

export enum QueryParams {
    ACCOUNT_ID = 'account_id',
    STATUS = 'status'
}

export type CostCenterListResponse = PaginatedResponse<CostCenter>;
export type CostCenterQueryParams = DefaultQueryParams & QueryParams;
